import React from 'react';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import clsx from 'clsx';
import DropdownStyles from './DropdownStyles';

const DropdownMenu = ({
  isBold,
  isMedium,
  selected,
  handleChangeSelected,
  items,
}) => (
  <DropdownStyles>
    <DropdownButton
      id={selected}
      title={selected}
      className={clsx(
        'dropdown-filter',
        isMedium && 'isMedium',
        isBold && 'isBold',
        selected && 'active'
      )}
      onSelect={handleChangeSelected}
    >
      {!items.includes('All') && (
        <Dropdown.Item key="all" eventKey="All">
          All
        </Dropdown.Item>
      )}
      {items.map(item => (
        <Dropdown.Item key={item.name || item} eventKey={item.name || item}>
          {item.name || item}
        </Dropdown.Item>
      ))}
    </DropdownButton>
  </DropdownStyles>
);

export default DropdownMenu;
